import { createTitleTimeline } from '../animations'

require('jquery-validation')

const dataAttrSuffix = 'section-contact-us'
const dataAttr = 'data-' + dataAttrSuffix

class SectionContactUs {
  constructor(target, args = {index: 0}) {
    this.target = target
    this.$el = $(this.target)

    this.titleTimeline = null
    this.$title = this.$el.find('[data-section-title]')

    this.$form = this.$el.find('[' + dataAttr + '-form]')
    const $form = this.$form

    const $provincesel = this.$form.find('#provincesel')
    this.$country = this.$form.find('#country')
    this.$country.on('change', function(e){
      if($(this).val()){
        $provincesel.removeAttr('disabled')
      } else {
        $provincesel.addAttr('disabled')
      }
    })

    // https://www.sitepoint.com/basic-jquery-form-validation-tutorial/
    // https://github.com/jquery-validation/jquery-validation
    // https://jqueryvalidation.org/documentation/
    // https://jqueryvalidation.org/validate/
    // https://jqueryvalidation.org/required-method/
    this.validator = this.$form.validate({
      errorElement: 'p', // adds aria-describedby="unique-id-here"
      groups: {
        privacyGroup: "privacy consenso_marketing"
      },
      errorPlacement: function(error, element) {
        if (element.attr("name") == "privacy" || element.attr("name") == "consenso_marketing" ) {
          error.insertAfter('.privacy-group');
        } else {
          error.insertAfter(element);
        }
      },
      rules: {
        privacy: {
          required: function(element) {
            return !$form.find('[name=consenso_marketing]:checked').length;
          }
        },
        consenso_marketing: {
          required: function(element) {
            return !$form.find('[name=privacy]:checked').length;
          }
        }
      },
      submitHandler: function(form) {
        form.submit();
      }
    })

    this.titleTimeline = createTitleTimeline(this.$title, true)
    this.titleTimeline.from(this.$form, { opacity: 0, y: 20, duration: 0.4 }, '>-=0.6')
  }


  destroy() {
    if (this.validator) {
      this.validator.destroy()
    }
    this.$country.off('change')

    if (this.titleTimeline) {
      this.titleTimeline.scrollTrigger.kill()
      this.titleTimeline.kill()
    }
  }
}

let sectionContactUsInstances = []

const init = function() {

  /*
  * Bootstrap validation

  // Fetch all the forms we want to apply custom Bootstrap validation styles to
  var forms = document.querySelectorAll('.needs-validation')

  // Loop over them and prevent submission
  Array.prototype.slice.call(forms)
    .forEach(function (form) {
      form.addEventListener('submit', function (event) {
        if (!form.checkValidity()) {
          event.preventDefault()
          event.stopPropagation()
        }

        form.classList.add('was-validated')
      }, false)
    })
  */

  $('[' + dataAttr + ']').each(function(index) {
    const spInstance = new SectionContactUs(this, {index: index})
    sectionContactUsInstances.push(spInstance)
  })
}

const destroy = function() {
  sectionContactUsInstances.forEach(spInstance => {
    spInstance.destroy()
  })
  sectionContactUsInstances = []
}

export default {dataAttr: dataAttr, sectionClass: SectionContactUs}
